// extracted by mini-css-extract-plugin
export default {"container":"lU-z","title":"mU-z","link":"nU-z"};